import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Producto } from '@shared/models/stock/Producto';
import { Tanque } from '@shared/models/stock/Tanque';

@Component({
  selector: 'app-modal-recepcion-combustible',
  templateUrl: './modal-recepcion-combustible.component.html',
  styleUrls: ['./modal-recepcion-combustible.component.scss']
})
export class ModalRecepcionCombustibleComponent implements OnInit {

  productosLista: Producto[];
  productos: Producto[];
  tanques: Tanque[];
  productosSeleccionados: Producto[] = [];

  productoForm = new UntypedFormGroup({
    productosFormControl: new UntypedFormControl(null)
  });
  
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.productos = this.productosLista;
  }

  agregarCombustible() {
    if(this.productos) {
      this.productosSeleccionados.push(this.productosLista.find(p => p.codigoProducto == this.productosFormControl.value));
      this.productos = this.productos.filter(p => p.codigoProducto != this.productosFormControl.value);
      this.productoForm.reset(); // resetea el form para seleccionar nuevamente un combustible. si no se hace queda trabado en el valor anterior
    }
  }

  eliminarCombustible(productoABorrar) {
    this.productos.push(productoABorrar);
    this.productosSeleccionados = this.productosSeleccionados.filter(p => p.codigoProducto != productoABorrar.codigoProducto)
  }

  get productosFormControl() {
    return this.productoForm.get('productosFormControl');
  }

  comenzarRecepcion() {
    this.activeModal.close(this.productosSeleccionados);
  }
  
}
